import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION6: PdfComponent = {
  type: 'section',
  id: 'iars6',
  title: '6. Complaints and Monitoring',
  content: [
    {
      type: 'bulletList',
      id: 'iars6bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'The Introducer must inform the Principal immediately if it or its staff:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'Are arrested, charged, or convicted of fraud or dishonesty;',
              },
              {
                copy: 'Are declared bankrupt or insolvent;',
              },
              {
                copy: 'Breach FCA or other regulatory rules;',
              },
              {
                copy: 'Become the subject of an FCA or other regulator investigation;',
              },
              {
                copy: 'Seek to appoint a different principal;',
              },
              {
                copy: 'Are disqualified from acting in financial services.',
              },
            ],
          },
        },
      ],
      prefix: '6',
    },
  ],
};
